// ThreadList is light-mode only. This module exists so older imports keep working.
export const getThemePref = () => "light";

export const applyTheme = () => {
  const root = document.documentElement;
  root.classList.remove("dark");
  root.style.colorScheme = "light";
  return false;
};

export const setThemePref = () => applyTheme();
